import { useCopies } from "shared/hooks/useCopies";
import { ImageAspectRatioWarningProps } from "./types";
import { Message } from "shared/components/message";

export default function ImageAspectRatioWarning(props: ImageAspectRatioWarningProps) {
  const copies = useCopies();
  return <Message.Warning text={props.message || copies.get("incorrect.aspect.ratio.warning")} hideIcon />;
}
